var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "errors-modal-window",
        size: "xl",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-footer": "",
        "hide-header": "",
        "content-class": "error-modal-content",
        "body-class":
          "modal-body-particle-container d-flex flex-column justify-content-center align-items-center"
      },
      on: { shown: _vm.handleModalShown, hidden: _vm.handleModalHidden },
      model: {
        value: _vm.showErrorModal,
        callback: function($$v) {
          _vm.showErrorModal = $$v
        },
        expression: "showErrorModal"
      }
    },
    [
      _c("div", { staticClass: "particle-viewport" }, [
        _c("canvas", {
          ref: "particleCanvas",
          attrs: { id: "particle-canvas" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-content-wrapper" },
          [
            _vm.offline
              ? [
                  _c(
                    "h2",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "text-danger mr-2",
                        attrs: { icon: "exclamation-triangle" }
                      }),
                      _vm._v("Соединение потеряно")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Не удалось установить соединение с сервером. Пожалуйста, проверьте ваше подключение."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "secondary" },
                      on: { click: _vm.refreshPage }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "sync-alt" }
                      }),
                      _vm._v("\n          Обновить страницу\n        ")
                    ],
                    1
                  )
                ]
              : _vm.notFound
              ? [
                  _c(
                    "h2",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "text-danger mr-2",
                        attrs: { icon: "exclamation-triangle" }
                      }),
                      _vm._v("Страница не найдена")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Ошибка 404. Такая страница не существует либо она была удалена."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "secondary" },
                      on: { click: _vm.onBack }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "chevron-left" }
                      }),
                      _vm._v("\n          Назад\n        ")
                    ],
                    1
                  )
                ]
              : _vm.forbidden
              ? [
                  _c(
                    "h2",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "text-danger mr-2",
                        attrs: { icon: "exclamation-triangle" }
                      }),
                      _vm._v("Доступ запрещён")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Ошибка 403. У вас нет прав для просмотра этой страницы, обратитесь к администратору."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "secondary" },
                      on: { click: _vm.onBack }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "chevron-left" }
                      }),
                      _vm._v("\n          Назад\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "secondary" },
                      on: { click: _vm.onHome }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "home" }
                      }),
                      _vm._v("\n          Домой\n        ")
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19f3b62a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f3b62a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alerts/ErrorsModalWindow.vue
// module id = null
// module chunks = 